"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evencomApiScopes = void 0;
var enum_1 = require("../enum");
exports.evencomApiScopes = [
    enum_1.Scopes.SelfServiceUserCreate,
    enum_1.Scopes.UsersRead,
];
